import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';

import { NotificationMessage } from '../components/WindowWidget/Chat/types';

type ChatContextType = {
  chatId: string;
  setChatId: Dispatch<SetStateAction<string>>;
  notificationMessage?: NotificationMessage;
  setNotificationMessage: Dispatch<
    SetStateAction<NotificationMessage | undefined>
  >;
};

export const ChatContext = createContext<ChatContextType>({
  chatId: '',
  setChatId: () => {},
  setNotificationMessage: () => {},
});

export const useChat = () => useContext(ChatContext);

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  const [chatId, setChatId] = useState('');
  const [notificationMessage, setNotificationMessage] =
    useState<NotificationMessage>();

  return (
    <ChatContext.Provider
      value={{
        chatId,
        setChatId,
        notificationMessage,
        setNotificationMessage,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
